import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { createTheme } from '@mui/material/styles';
import { getUsersNfts } from 'APIs/HotAuctionApi';
import Loader from 'components/atoms/loader';
import NftCard from 'components/molecules/Card/NftCard';
import NftData from 'interfaces/NftData.interface';
import * as React from 'react';
import Media from 'react-media';
import { useLocation } from 'react-router-dom';
import MobileExplorePage from './FeedBody';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const GalleryBody = () => {
  const [nfts, setNfts] = React.useState<NftData[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const location = useLocation();
  React.useEffect(() => {
    const getNfts = async () => {
      setLoading(true);
      const data = await getUsersNfts(location.pathname.split('/')[2]);
      setNfts(data.data);
      setLoading(false);
    };
    getNfts();
    //eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box>
          <Media query="(max-width: 599px)">
            {matches =>
              matches ? (
                <MobileExplorePage />
              ) : (
                <Grid
                  container
                  style={{
                    gap: '40px',
                    maxWidth: '1300px',
                    justifyContent: 'start',
                  }}
                >
                  {loading ? (
                    <Loader
                      sx={{
                        width: '100%',
                        minHeight: '500px',
                        displat: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    />
                  ) : (
                    nfts.map(nft => {
                      return (
                        <Grid item key={nft.id}>
                          <NftCard
                            splitWith={nft.username}
                            currency={'ETH'}
                            ownerName={nft.username}
                            views={nft.views}
                            name={nft.title}
                            price={nft.reservedBid.toString()}
                            image={nft.image}
                            id={nft.id}
                            userAvatar={nft.user.avatar}
                            poster={nft.poster}
                          />
                        </Grid>
                      );
                    })
                  )}
                </Grid>
              )
            }
          </Media>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default GalleryBody;
